export default ({
  name,
  formikProps: {
    setFieldValue,
  },
}) => (date) => (
  setFieldValue(name, date)
)
